<svg [innerHTML]="sanitizedSvg"></svg>
